"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HeadingButton_1 = __importDefault(require("./Heading/HeadingButton"));
const ParagraphButton_1 = __importDefault(require("./Paragraph/ParagraphButton"));
const PreformattedButton_1 = __importDefault(require("./Preformatted/PreformattedButton"));
const CodeBlockButton_1 = __importDefault(require("./CodeBlock/CodeBlockButton"));
const ToolbarDropdown_1 = __importDefault(require("../../../ui/ToolbarDropdown/ToolbarDropdown"));
const react_2 = require("@remirror/react");
const TextTypeDropdown = () => {
    const active = (0, react_2.useActive)();
    const activeLabel = () => {
        // Determine if preformatted is active
        if (active.preformatted()) {
            return 'Preformatted';
        }
        // Determine if codeblock is active
        if (active.codeBlock()) {
            return 'Code block';
        }
        // Determine if a heading is active
        for (let i = 1; i <= 6; i++) {
            if (active.heading({ level: i })) {
                return `Heading ${i}`;
            }
        }
        // Default to paragraph
        return 'Paragraph';
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ToolbarDropdown_1.default, { label: activeLabel() },
            react_1.default.createElement(ParagraphButton_1.default, null),
            react_1.default.createElement(HeadingButton_1.default, { level: 1 }),
            react_1.default.createElement(HeadingButton_1.default, { level: 2 }),
            react_1.default.createElement(HeadingButton_1.default, { level: 3 }),
            react_1.default.createElement(HeadingButton_1.default, { level: 4 }),
            react_1.default.createElement(HeadingButton_1.default, { level: 5 }),
            react_1.default.createElement(HeadingButton_1.default, { level: 6 }),
            react_1.default.createElement(PreformattedButton_1.default, null),
            react_1.default.createElement(CodeBlockButton_1.default, null)),
        react_1.default.createElement(react_2.VerticalDivider, null)));
};
exports.default = TextTypeDropdown;
